import { getMediasWithoutErrors } from '@prismamedia/one-components';
import { omit } from 'lodash';
import type { Category, CategoryForm } from '../types';
import { getCategorySection } from './categorySection.model';

export const getCategory = <M extends CategoryForm>({
  description,
  descriptionSEO,
  medias,
  sections,
  subTitle,
  tags,
  hasDragAndDropOccurred,
  ...restCategoryForm
}: M & { hasDragAndDropOccurred?: boolean }): Partial<Category> & {
  hasDragAndDropOccurred?: boolean;
} => {
  return {
    ...omit(restCategoryForm, 'createdAt', 'editedAt', 'updatedAt'),
    description: descriptionSEO,
    body: description ? description : null,
    subtitle: subTitle,
    medias: medias ? getMediasWithoutErrors(medias) : null,
    tabs: sections.map(getCategorySection),
    tags,
    ...(hasDragAndDropOccurred !== undefined && { hasDragAndDropOccurred }),
  };
};
